import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CounsellorHero.css';
import counsellorHeroBg from '../../assets/images/counsellorherobg.png';
import SearchBar from '../Blog/SearchBar';

const CounsellorHero = ({ isSearchMode = false }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/counsellor?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <section className={`counselor-hero-section ${isSearchMode ? 'search-mode' : ''}`}>
      <div className="counselor-hero-bg-layer">
        <img src={counsellorHeroBg} alt="Background" className="counselor-hero-bg-img" />
        <div className="counselor-hero-overlay"></div>
      </div>
      
      <div className="counselor-hero-content">
        <h1 className="counselor-hero-heading">
          Find right<br />
          Career Counselor
        </h1>
        
        <p className="counselor-hero-subtext">
          Discover expert counsellors who can help you choose the right course, college, and career direction based on your strengths and aspirations.
        </p>
        
        <div className="hero-search-wrapper">
          <SearchBar 
            placeholder="Search by name, career, or keywords" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onSearch={handleSearch}
            style={{ width: '100%', maxWidth: '634px' }}
          />
        </div>
        
        <div className="search-tags">
          <span className="popular-label">Popular searches: </span>
          <span className="featured-tag" style={{ fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer' }}>Development</span>,
          <span className="plain-tag"> Data science,</span>
          <span className="plain-tag"> Medical Science,</span>
          <span className="plain-tag"> finance,</span>
          <span className="plain-tag"> Accounts</span>
        </div>
      </div>
    </section>
  );
};

export default CounsellorHero;
